import { createTheme, alpha, lighten } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

const fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

const learningCenterTheme = (primaryColor, secondaryColor) => ({
  palette: {
    primary: {
      main: primaryColor,
      light: lighten(primaryColor, 0.85),
      contrastText: "#fff"
    },
    background: {
      default: "#fafafa"
    },
    body: "#fafafa",
    secondary: {
      main: secondaryColor,
      A200: "#E6F7F7",
      A400: "#ECEBFF"
    },
    action: {
      hover: alpha(primaryColor, 0.04)
    },
    table: {
      filterRow: "#fafafa"
    }
  },

  shape: {
    borderRadius: 0
  },
  gradient: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
  components: {
    MuiButton: {
      styleOverrides: {
        sizeSmall: {
          fontWeight: 500
        }
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          minHeight: 48
        },
        title: {
          fontWeight: "400"
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          lineHeight: 1
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow:
            "0px 2px 10px rgba(0, 0, 0, 0.06), 0px 0px 4px rgba(0, 0, 0, 0.06)"
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: 64
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          "&.nav-item": {
            textTransform: "capitalize",
            whiteSpace: "nowrap",
            fontSize: "0.8125rem",
            fontFamily,
            fontWeight: 500
          }
        },
        overline: {
          letterSpacing: 1
        },
        caption: {
          letterSpacing: 0
        },
        h1: {
          fontSize: "3rem",
          fontWeight: 400
        },
        h2: {
          lineHeight: 1.165,
          fontWeight: 400,
          fontSize: "2.25rem"
        },
        h3: {
          fontWeight: 400,
          fontSize: "1.875rem"
        },
        h4: {
          fontWeight: 400
        },
        h5: {
          fontWeight: 400
        },
        h6: {
          fontWeight: 400
        },
        subtitle1: {
          fontWeight: 500,
          letterSpacing: 0
        },
        subtitle2: {
          fontWeight: 500
        },
        button: {
          fontWeight: 500
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        sizeSmall: {
          height: 16
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: "#EEEEEE"
        }
      }
    }
  },
  typography: {
    fontFamily,
    body1: {
      fontFamily
    },
    body2: {
      fontFamily
    },
    button: {
      fontFamily
    },
    caption: {
      fontFamily
    },
    h1: {
      fontFamily
    },
    h2: {
      fontFamily
    },
    h3: {
      fontFamily
    },
    h4: {
      fontFamily
    },
    h5: {
      fontFamily
    },
    h6: {
      fontFamily
    },
    overline: {
      fontFamily
    },
    subtitle1: {
      fontFamily
    },
    subtitle2: {
      fontFamily
    }
  }
});

const theme = outerTheme => {
  const nestedTheme = createTheme(
    deepmerge(
      outerTheme,
      learningCenterTheme(
        outerTheme.palette.primary.main,
        outerTheme.palette.secondary.main
      )
    )
  );

  return nestedTheme;
};

export default theme;
